/* eslint-disable */
import React from 'react'
import './Orders.css'
import moment from 'moment'
import { isEmpty, map } from 'lodash'
import Card from 'components/Card/Card.jsx'
import Select from 'react-select'
import 'react-select/dist/react-select.css'
import { db, keygen } from '../../services/firebase'
import { PulseLoader } from 'react-spinners'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { Grid, Row, Col, Breadcrumb } from 'react-bootstrap'

const options = [
    { value: 'new', label: 'Novo' },
    { value: 'waiting', label: 'Processando' },
    { value: 'sent', label: 'Enviado' },
    { value: 'delivered', label: 'Entregue' },
    { value: 'cancelled', label: 'Cancelado' }
]

export default class OrderDetails extends React.Component {

    state = {
        loading: true,
        order: null,
        status: null,
        discountRegion: null,
        savingStatus: false
    }

    componentDidMount() {
        const { id } = this.props.match.params
        if (!id) {
            this.props.history.push('/orders')
            this.props.notify('Pedido não encontrado.', 'error')
        } else {
            this._fetchOrder(id)
        }
    }

    render() {
        const { order, status, savingStatus } = this.state
        return (
            <div className='main-content'>

                <Breadcrumb style={{ padding: 0, marginBottom: 7, marginTop: 10 }}>
                    <Breadcrumb.Item onClick={() => this.props.history.push('/orders')}>
                        <FontAwesomeIcon icon='chevron-left' className='text-default' /> <span className='text-default'>Pedidos</span>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item href='#' active>
                        <b>{!isEmpty(order) ? `Pedido #${order.orderNumber}` : '...'}</b>
                    </Breadcrumb.Item>
                </Breadcrumb>

                <Card
                    content={
                        <Grid fluid>
                            <Row className='orders__header'>
                                <Col md={6}>
                                    <span className='orders__header_title'>
                                        Pedido {!isEmpty(order) ? `#${order.orderNumber}` : '...'}
                                    </span>
                                </Col>
                                <Col md={6} className='orders__controls'>
                                    <b className='orders__controls__label'>Status</b>
                                    <Select
                                        className='orders__controls__input'
                                        value={status}
                                        options={options}
                                        disabled={!status}
                                        placeholder=''
                                        onChange={this._handleStatus}
                                    />
                                    <div className={`orders__controls__spinner ${savingStatus && 'saving__status'}`}>
                                        <PulseLoader color={'#703A29'} size={7} />
                                    </div>
                                </Col>
                            </Row>
                            {this._handleContent()}
                        </Grid>
                    } />
            </div>
        )
    }

    _handleStatus = selectedStatus => {
        const { order } = this.state
        const { id } = this.props.match.params

        this.setState({ status: null, savingStatus: true })

        db.collection('orders').doc(id).update({ status: selectedStatus.value })
            .then(() => {
                this.setState({ status: selectedStatus.value, savingStatus: false })
                this.props.notify('Status atualizado.', 'success')
            })
            .catch(e => {
                this.setState({ status: order.status, savingStatus: false })
                this.props.notify('Erro ao atualizar status.', 'error')
            })
    }

    _handleContent = _ => {
        const { loading, order, discountRegion } = this.state

        if (loading) {
            return (
                <Row>
                    <Col md={12}>
                        <PulseLoader color={'#703A29'} size={7} />
                    </Col>
                </Row>
            )
        } else {
            return (
                <div>
                    <Row>
                        <Col md={6} className='order__info'>
                            <h4><b>{!isEmpty(order) ? order.partner.tradingName : '...'}</b></h4>
                            <span>{!isEmpty(order) ? this._maskCPNJ(order.partner.cnpj) : '...'}</span><br />
                            <span>{!isEmpty(order) ? `${order.partner.address} - ${order.partner.district}` : '...'}</span><br />
                            <span>{!isEmpty(order) ? `${order.partner.city} - ${order.partner.state}    ` : '...'}</span>
                        </Col>

                        <Col md={6} className='order__payment'>
                            <h5><b>{!isEmpty(order) ? moment(order.date).format('DD/MM/YYYY') : '...'}</b></h5>
                            <h5 className='order__region'><b>{discountRegion || '...'}</b></h5>
                            <span>Condição de pagamento: {!isEmpty(order) ? `${order.payment.name}` : '...'}</span>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={12}>
                            <h5 className='order__region'>Observações</h5>
                            <span>{order.observations || 'Nenhuma observação'}</span>
                        </Col>
                    </Row>

                    <Row className='order__products'>
                        {!isEmpty(order) && map(order.products, product => (
                            <Col xs={12} className='order__product' key={keygen()}>
                                <h5 className='order__region'>{product.model}</h5>
                                {product.items && this._renderTable(this._prepareTableData(product.items))}
                                {!product.items && this._renderTable(this._prepareTableData(product))}
                            </Col>
                        ))}
                    </Row>

                    <Row className='order__total-price'>
                        <Col md={12}>
                            <h4><b>Total: R$ {!isEmpty(order) ? this._handleTotalPrice(order.products) : '...'}</b></h4>
                        </Col>
                    </Row>
                </div>
            )
        }
    }

    _handleTotalPrice = products => {
        let output = new Number(0)

        map(products, product => {
            product.items && map(product.items, item => {
                let factory = Number(parseFloat(item.factoryPrice.replace(',', '.')).toFixed(2))
                output += factory
            })

            if (!product.items) {
                let factory = parseFloat(product.factoryPrice.replace(',','.'))
                output += factory
            }
        })
        return parseFloat(output).toFixed(2).replace('.', ',')
    }

    _prepareTableData = dataToPrepare => {
        const data = []
        if (typeof (dataToPrepare) === 'object' && !dataToPrepare.hasOwnProperty('item')) {
            map(dataToPrepare, d => {
                let newEntry = {
                    item: `${d.name} ${d.description}`,
                    price: `R$ ${d.factoryPrice}`,
                    composition: this._handleComposition(d.composition)
                }

                data.push(newEntry)
            })
        }

        if (typeof (dataToPrepare) === 'object' && dataToPrepare.hasOwnProperty('item')) {
            data.push({
                item: dataToPrepare.item,
                price: dataToPrepare.factoryPrice,
                composition: this._handleComposition(dataToPrepare.composition)
            })
        }

        return data
    }


    _checkComposition = composition => {
        let validation = false

        map(Object.keys(composition), key => {
            typeof (composition[key]) === 'object' ? validation = true : validation = false
        })

        return validation
    }

    _handleComposition = composition => {
        let output = ''
        let multipleFabrics = this._checkComposition(composition)

        if (multipleFabrics) {
            map(composition, c => {
                output += `${c.name} (${c.percentage}%) `
            })
        }

        if (!multipleFabrics) {
            output = `${composition.name} (${composition.percentage}%)`
        }

        return output
    }

    _renderTable = data => (
        <div className='tbl_wrapper'>
            <Row className='tbl_header'>
                <Col xs={6}>Item</Col>
                <Col xs={4}>Composição</Col>
                <Col xs={2}>Valor</Col>
            </Row>

            {map(data, d => (
                <Row className='tbl_row' key={keygen()}>
                    <Col xs={6}>{d.item}</Col>
                    <Col xs={4}>{d.composition}</Col>
                    <Col xs={2}>{d.price}</Col>
                </Row>
            ))}

        </div>
    )

    _maskCPNJ = cnpj => {
        let x = /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/.exec(cnpj)
        return `CNPJ ${x[1]}.${x[2]}.${x[3]}/${x[4]}-${x[5]}`
    }

    _fetchOrder = id => {
        db.collection('orders').doc(id).get()
            .then(snapshot => {
                if (snapshot.exists) {
                    this.setState({ order: { ...snapshot.data() }, loading: false, status: snapshot.data().status })
                    this._fetchDiscountRegion(snapshot.data().partner.discount)
                }

                if (!snapshot.exists) {
                    this.props.history.push('/orders')
                    this.props.notify('O pedido selecionado não existe.', 'error')
                }
            })
            .catch(e => {
                console.log(e)
                this.props.history.push('/orders')
                this.props.notify('Erro ao buscar pedido.', 'error')
            })
    }

    _fetchDiscountRegion = discountID => {
        db.collection('discounts').doc(discountID).get()
            .then(snapshot => snapshot.exists && this.setState({ discountRegion: snapshot.data().name }))
            .catch(e => console.log(e))
    }

}



// WEBPACK FOOTER //
// ./src/views/Orders/OrderDetails.jsx